
import React from 'react';
import { Badge } from '@/components/ui/badge';
import { Paper } from '@/types/paper';
import { getArxivCategoryName } from '@/utils/category-mapping';

interface PaperCardCategoriesProps {
  paper: Paper;
}

const PaperCardCategories: React.FC<PaperCardCategoriesProps> = ({ paper }) => {
  return (
    <div className="flex flex-wrap gap-1 md:gap-1.5 mb-3">
      {paper.category && (
        <Badge variant="secondary" className="font-normal text-xs px-2 py-0.5">
          {getArxivCategoryName(paper.category)}
        </Badge>
      )}
      
      {paper.keywords?.slice(0, 2).map((keyword, index) => (
        <Badge key={index} variant="outline" className="font-normal text-[10px] md:text-xs px-1.5 py-0.5">
          {keyword}
        </Badge>
      ))}
      
      {paper.keywords && paper.keywords.length > 2 && (
        <Badge variant="outline" className="font-normal text-[10px] md:text-xs px-1.5 py-0.5">
          +{paper.keywords.length - 2}
        </Badge>
      )}
    </div>
  );
};

export default PaperCardCategories;
